import { createApp } from 'vue'

import AdminSettings from './AdminSettings.vue'

const app = createApp(AdminSettings)
app.mount('#externalportal_prefs')
